import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';

import { CohortBuilderEmptyStateCard } from '../../../../components/CohortBuilderEmptyStateCard/CohortBuilderEmptyStateCard';
import { CohortSectionHeader } from '../../../../components/CohortSection/CohortSectionHeader/CohortSectionHeader';

export type CohortTranslationProps = {
  title: string;
  emptyStateMainMessage: string;
  emptyStateSubMessage: string;
  content?: JSX.Element[] | JSX.Element | string;
};

export const CohortTranslation = ({
  title,
  emptyStateMainMessage,
  emptyStateSubMessage,
  content,
}: CohortTranslationProps) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <CohortSectionHeader title={title} />
      </AccordionSummary>
      <AccordionDetails>
        {content ? (
          <Box
            component="span"
            sx={{
              display: 'block',
              p: 1,
              m: 1,
              width: '100%',
              bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
              color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
              border: '1px solid',
              borderColor: (theme) => (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300'),
              borderRadius: 2,
              fontSize: '14px',
              fontWeight: '700',
            }}
          >
            {content}
          </Box>
        ) : (
          <CohortBuilderEmptyStateCard
            id="no-cohort-translation"
            mainMessage={emptyStateMainMessage}
            subMessage={emptyStateSubMessage}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
};
